import { generateUOMTypeURL } from "c8-platform";
import resolver from "csi/resolver";
import New from "csi/table/New";
import { ATTR_NAME } from "csi/typings";
import declare from "dojo/_base/declare";

const NewUOMType = declare(New, {

	/**
	 * @override
	 * Show newly created UOMType nodes
	 */
	getNewNodes() {
		const formData = this.getFormData();
		const uomTypeName = formData.getFieldValue(ATTR_NAME);
		const newUOMType = resolver.resolveNode(generateUOMTypeURL(uomTypeName), true, null);
		return [newUOMType];
	},

});

export = NewUOMType;